import {UseListParamsReturn} from '../../../hooks/listParams';
import {useListSearchParams} from '../../../hooks/useListSearchParams';
import {SORT_DEFAULT} from '../../../constants';

export function useRoomsListSearchParams(): UseListParamsReturn {
    return useListSearchParams({sortBy: SORT_DEFAULT}, {sort: {allowedFields: ['roomName', 'lastModified']}});
}
